module.exports = __webpack_public_path__ + "img/everrise.74a268b6.jpeg";